/* ══════════════════════════════════════════════════════════════
   BRUTECH PARTNER BRAND SYSTEM
   Future-proof registry. Add a brand = add one object entry.
   No Liquid, no backdrop-filter, no will-change. Mobile safe.
   Load AFTER brutech-custom.js
══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── 1. BRAND REGISTRY ──────────────────────────────────────
     To add a brand, copy a block and change the values.
     match:  lowercase strings found in product title / vendor / url
     tiers:  the brand's OWN tier ladder, mapped to rarity slots
     cats:   category label overrides for the stat bar
  ─────────────────────────────────────────────────────────── */
  var PARTNER_BRANDS = {

    lorgar: {
      key:      'lorgar',
      label:    'LORGAR',
      tagline:  'Ready to Play.',
      eyebrow:  '// LORGAR ARSENAL',
      tribe:    'JOIN THE TRIBE',
      cta:      'ENTER THE TRIBE',
      match:    ['lorgar', 'lrg-'],
      /* Brand palette — near-black canvas, violet accent, white type */
      ink:      '#08080c',
      panel:    '#101018',
      accent:   '#8a2be2',
      accentRgb:'138,43,226',
      edge:     '#c9a6ff',
      edgeRgb:  '201,166,255',
      text:     '#ffffff',
      /* Brand's own tier ladder → rarity slot */
      tiers: {
        advanced: { label: 'ADVANCED', rarity: 'rare',      intensity: 0.45 },
        pro:      { label: 'PRO',      rarity: 'epic',      intensity: 0.75 },
        elite:    { label: 'ELITE',    rarity: 'legendary', intensity: 1.00 }
      },
      tierOrder: ['advanced', 'pro', 'elite'],
      /* Model → tier.
         MIRRORS snippets/brutech-lorgar-tier-map.liquid, which is the
         source of truth. Product pages resolve tier from the SKU (exact);
         this map covers collection cards, where SKU is not in the markup,
         by matching the model designation in the product title.

         Series names alone are NOT usable: Noah 101 is Advanced while
         Noah 702 is Elite, and Voicer 521 is Pro while Voicer 721 is
         Elite. Always match model, never series.

         KEEP IN SYNC with the Liquid map. */
      models: {
        'azar 514':   'advanced',
        'jetter 357': 'advanced',
        'kaya 360':   'pro',
        'kaya 460':   'pro',
        'kbp7075w':   'advanced',
        'kbp70tklw':  'advanced',
        'kbp70mw':    'advanced',
        'msa10w':     'advanced',
        'msa10':      'advanced',
        'msp80':      'advanced',
        'mpa14xl':    'advanced',
        'mpa15xl':    'advanced',
        'noah 101':   'advanced',
        'noah 702':   'elite',
        'stricter 579': 'pro',
        'trix-510':   'pro',
        'trix 510':   'pro',
        'main 319':   'advanced',
        'steller 913': 'pro',
        'steller 919': 'pro',
        'voicer 521': 'pro',
        'voicer 721': 'elite',
        'legacer 753': 'elite',
        'legacer 755': 'elite',
        'rapax 701':  'elite'
      },
      /* Stat bar labels per product category */
      cats: {
        mouse:      { icon:'🖱', tag:'PRECISION',  stats:['DPI','POLLING','SWITCH'] },
        keyboard:   { icon:'⌨', tag:'INPUT',      stats:['SWITCH','LAYOUT','BACKLIT'] },
        headset:    { icon:'🎧', tag:'AUDIO',      stats:['DRIVER','CONNECT','BATTERY'] },
        controller: { icon:'🎮', tag:'CONTROL',    stats:['CONNECT','TRIGGER','BATTERY'] },
        webcam:     { icon:'📷', tag:'CAPTURE',    stats:['RES','FPS','FOV'] },
        simracing:  { icon:'🏁', tag:'SIM RACING', stats:['FORCE','ROTATION','MOUNT'] }
      },
      perk: { label:'PLATFORM READY', url:'/pages/lorgar-platform' }
    }

    /* ── ADD NEXT BRAND HERE ──
       Copy the lorgar block above, add a comma after its closing brace,
       and change the values. Nothing else needs editing: no CSS, no
       templates, no sections. Colours are read from these keys at runtime.
    ───────────────────────── */
  };

  /* ── 2. CATEGORY DETECTION ── */
  /* Order matters. "Gaming Mouse Pad" contains the word "mouse", so the
     mousepad test has to run first or every pad lands in the mouse slot. */
  var CAT_RE = [
    ['simracing',  /sim.?racing|cockpit|racing.?wheel|pedal|shifter|handbrake/],
    ['mousepad',   /mouse\s?pad|mousepad|mouse\s?mat|desk\s?mat|deskmat|\bmpa\d|\bgmp\d/],
    ['mouse',      /\bmouse\b|\bmice\b|\bgm\d|\bgms\d|\bmsa\d|\bmsp\d/],
    ['keyboard',   /keyboard|\bgk\d|\bkb\d|\bkbp\d/],
    ['headset',    /headset|headphone|\bhs\d|\bghs\d/],
    ['microphone', /microphone|\bmics\b|\bcmt\d/],
    ['chair',      /\bchair\b|seating|\bcmp\d/],
    ['controller', /controller|gamepad|\bgp\d/],
    ['webcam',     /webcam|web.?camera|\bcam\d|streaming\s?camera|\bsc\d/]
  ];

  function detectCategory(text) {
    for (var i = 0; i < CAT_RE.length; i++) {
      if (CAT_RE[i][1].test(text)) return CAT_RE[i][0];
    }
    return null;
  }

  /* ── 3. BRAND + TIER DETECTION ── */
  function detectBrand(text) {
    for (var k in PARTNER_BRANDS) {
      if (!PARTNER_BRANDS.hasOwnProperty(k)) continue;
      var b = PARTNER_BRANDS[k];
      for (var i = 0; i < b.match.length; i++) {
        if (text.indexOf(b.match[i]) !== -1) return b;
      }
    }
    return null;
  }

  function detectTier(brand, text) {
    /* 1. explicit tier word in the title, e.g. "Elite 90" */
    for (var i = 0; i < brand.tierOrder.length; i++) {
      var tk = brand.tierOrder[i];
      if (new RegExp('\\b' + tk + '\\b').test(text)) return brand.tiers[tk];
    }

    /* 2. model designation. Longest match wins so "msa10w" is not
       swallowed by "msa10", and "noah 702" is not read as just "noah". */
    if (brand.models) {
      var bestLen = 0, bestTier = null;
      for (var name in brand.models) {
        if (!brand.models.hasOwnProperty(name)) continue;
        if (text.indexOf(name) !== -1 && name.length > bestLen) {
          bestLen = name.length;
          bestTier = brand.models[name];
        }
      }
      if (bestTier) return brand.tiers[bestTier] || null;
    }
    return null;
  }

  /* ── 4. READ CARD TEXT ── */
  function cardText(card) {
    var bits = [];
    var t = card.querySelector('.product-card__title, a.h5, .product-title, h3, h2');
    if (t) bits.push(t.textContent || '');
    var a = card.querySelector('a[href*="/products/"], a[href*="/collections/"]');
    if (a) bits.push(a.getAttribute('href') || '');
    var v = card.querySelector('.product-card__vendor, .product-vendor');
    if (v) bits.push(v.textContent || '');
    if (card.dataset.productVendor) bits.push(card.dataset.productVendor);
    return bits.join(' ').toLowerCase();
  }

  /* ── 5. APPLY BRAND TO A CARD ── */
  function brandCard(card) {
    if (card.dataset.brutechPartner) return;
    var text  = cardText(card);
    var brand = detectBrand(text);
    if (!brand) return;

    card.dataset.brutechPartner = brand.key;
    card.setAttribute('data-partner', brand.key);
    card.classList.add('brutech-partner-card');

    /* Inject brand colours — overrides the rarity glow vars */
    card.style.setProperty('--brutech-glow-rgb', brand.accentRgb);
    card.style.setProperty('--brutech-rarity-hex', brand.accent);
    card.style.setProperty('--bp-ink', brand.ink);
    card.style.setProperty('--bp-panel', brand.panel);
    card.style.setProperty('--bp-accent', brand.accent);
    card.style.setProperty('--bp-accent-rgb', brand.accentRgb);
    card.style.setProperty('--bp-edge', brand.edge);
    card.style.setProperty('--bp-edge-rgb', brand.edgeRgb);

    /* Tier → rarity slot, but keeps brand colour */
    var tier = detectTier(brand, text);
    if (tier) {
      card.setAttribute('data-partner-tier', tier.label.toLowerCase());
      card.style.setProperty('--bp-intensity', tier.intensity);

      var existing = card.querySelector('.brutech-rarity-badge');
      var badge = existing || document.createElement('span');
      badge.className = 'brutech-rarity-badge brutech-partner-tier-badge';
      badge.textContent = tier.label;
      if (!existing) {
        var fig = card.querySelector('.product-card__figure') || card;
        fig.style.position = 'relative';
        fig.appendChild(badge);
      }
    }

    /* Category label on the stat bar */
    var cat = detectCategory(text);
    if (cat && brand.cats && brand.cats[cat]) {
      card.setAttribute('data-partner-cat', cat);
      var c = brand.cats[cat];
      var fig2 = card.querySelector('.product-card__figure') || card;
      if (!card.querySelector('.brutech-partner-cat')) {
        var chip = document.createElement('span');
        chip.className = 'brutech-partner-cat';
        chip.innerHTML = '<span class="brutech-partner-cat-icon">' + c.icon + '</span>' + c.tag;
        fig2.style.position = 'relative';
        fig2.appendChild(chip);
      }
    }

    /* Perk badge */
    if (brand.perk && !card.querySelector('.brutech-perk-badge')) {
      var body = card.querySelector('.product-card__info, .product-card__content') || card;
      var perk = document.createElement('a');
      perk.className = 'brutech-perk-badge brutech-partner-perk';
      perk.href = brand.perk.url;
      perk.textContent = brand.perk.label;
      body.appendChild(perk);
    }
  }

  /* ── 6. COLLECTION TAKEOVER ── */
  function initTakeover() {
    /* Collection pages only.

       A product URL such as /products/lorgar-jetter-357 also contains
       "lorgar", so matching the whole pathname made this fire on product
       pages and inject the collection eyebrow and tier ladder around the
       product title. Product pages get their own treatment in
       initProductPage() below. */
    var path = window.location.pathname.toLowerCase();
    var isCollection = path.indexOf('/collections/') !== -1;
    var isProduct    = path.indexOf('/products/') !== -1;

    if (isProduct || !isCollection) return;

    /* Match on the collection handle only, not the full path */
    var handle = path.split('/collections/')[1] || '';
    handle = handle.split('/')[0].split('?')[0];

    /* The collection HANDLE must name the brand. No card-majority
       fallback: a generic category like /collections/gaming-mice can
       be mostly LORGAR by stock, and branding it would hijack a page
       that is not a brand page. Only /collections/lorgar takes over. */
    var brand = detectBrand(handle);
    if (!brand) return;

    var root = document.documentElement;
    document.body.classList.add('brutech-partner-takeover');
    document.body.setAttribute('data-partner-active', brand.key);

    root.style.setProperty('--bp-ink', brand.ink);
    root.style.setProperty('--bp-panel', brand.panel);
    root.style.setProperty('--bp-accent', brand.accent);
    root.style.setProperty('--bp-accent-rgb', brand.accentRgb);
    root.style.setProperty('--bp-edge', brand.edge);
    root.style.setProperty('--bp-edge-rgb', brand.edgeRgb);
    root.style.setProperty('--bp-text', brand.text);

    /* Brand eyebrow above the collection title */
    var heading = document.querySelector('.collection__title, .section-header h1, main h1');
    if (heading && !document.querySelector('.brutech-partner-eyebrow')) {
      var ey = document.createElement('div');
      ey.className = 'brutech-partner-eyebrow';
      ey.innerHTML = '<span class="brutech-partner-dot"></span>' + brand.eyebrow;
      heading.parentNode.insertBefore(ey, heading);
    }

    /* Tier ladder strip */
    if (heading && brand.tierOrder && !document.querySelector('.brutech-tier-ladder')) {
      var strip = document.createElement('div');
      strip.className = 'brutech-tier-ladder';
      var html = '<span class="brutech-tier-ladder-label">TIERS</span>';
      brand.tierOrder.forEach(function (tk) {
        var t = brand.tiers[tk];
        html += '<span class="brutech-tier-chip" data-tier="' + tk +
                '" style="--bp-intensity:' + t.intensity + '">' + t.label + '</span>';
      });
      strip.innerHTML = html;
      heading.parentNode.insertBefore(strip, heading.nextSibling);
    }
  }

  /* ── 6b. PRODUCT PAGE ──
     Separate from the collection takeover. Overrides the theme's own
     rarity accent (--rc) so a LORGAR product does not inherit Brutech
     rarity colours, and places a single tier ribbon above the title. */
  function initProductPage() {
    var path = window.location.pathname.toLowerCase();
    if (path.indexOf('/products/') === -1) return;

    /* The custom LORGAR template renders its own tier ribbon and sets
       its own palette in Liquid. Colour it, but do not inject anything. */
    var customTemplate = document.querySelector('[data-lg-page]');

    /* Read the brand from vendor or title, not the URL */
    var bits = [];
    var vendorEl = document.querySelector('.bp-series, .product-vendor, [itemprop="brand"]');
    if (vendorEl) bits.push(vendorEl.textContent || '');
    var titleEl = document.querySelector('.bp-title, .bp-info h1, main h1');
    if (titleEl) bits.push(titleEl.textContent || '');
    bits.push(path);

    var brand = detectBrand(bits.join(' ').toLowerCase());
    if (!brand) return;

    document.body.classList.add('brutech-partner-product');
    document.body.setAttribute('data-partner-active', brand.key);

    /* Brand palette, including an override of the theme's --rc accent */
    var wrap = document.querySelector('.bp-wrap') || document.body;
    [document.documentElement, wrap].forEach(function (el) {
      el.style.setProperty('--bp-ink', brand.ink);
      el.style.setProperty('--bp-panel', brand.panel);
      el.style.setProperty('--bp-accent', brand.accent);
      el.style.setProperty('--bp-accent-rgb', brand.accentRgb);
      el.style.setProperty('--bp-edge', brand.edge);
      el.style.setProperty('--bp-edge-rgb', brand.edgeRgb);
      el.style.setProperty('--bp-text', brand.text);
      /* the theme's own accent, used in 17 places on this template */
      el.style.setProperty('--rc', brand.accent);
      el.style.setProperty('--rg', 'rgba(' + brand.accentRgb + ',0.28)');
    });

    /* Custom template already has its own ribbon in the markup */
    if (customTemplate) return;

    /* Single tier ribbon above the title. No ladder, no eyebrow, those
       belong on the collection page. */
    var text = bits.join(' ').toLowerCase();

    /* Tier can come from three places, in priority order:
       1. an explicit data attribute rendered by the template
       2. a Shopify metafield exposed as data-partner-tier on .bp-wrap
       3. a tier word in the product title
       Most real SKU names (Jetter 357, Noah 701) carry no tier word, so
       the metafield is the reliable route. */
    var tier = null;
    var explicit = (document.body.getAttribute('data-partner-tier')
                 || (wrap.getAttribute && wrap.getAttribute('data-partner-tier'))
                 || '').toLowerCase().trim();

    if (explicit && brand.tiers[explicit]) {
      tier = brand.tiers[explicit];
    } else {
      tier = detectTier(brand, text);
    }

    if (!tier || document.querySelector('.bl-tier-ribbon')) return;

    var anchor = document.querySelector('.bp-series')
              || document.querySelector('.bp-title-area')
              || titleEl;
    if (!anchor) return;

    var ribbon = document.createElement('span');
    ribbon.className = 'bl-tier-ribbon';
    ribbon.setAttribute('data-tier', tier.label.toLowerCase());
    ribbon.style.setProperty('--bp-intensity', tier.intensity);
    ribbon.innerHTML = '<span class="bl-tier-ribbon-dot"></span>' +
                       brand.label + ' · ' + tier.label;

    anchor.parentNode.insertBefore(ribbon, anchor);
  }

  /* ── 6c. PC BUILDER HIGHLIGHT ──
     The builder renders .pcb__card in JS, so we tag cards after they
     appear rather than editing the 5,000-line builder section. */
  var TIERS = null;

  function tierFor(name) {
    if (!TIERS) {
      TIERS = (window.BrutechPartners &&
               window.BrutechPartners.brands &&
               window.BrutechPartners.brands.lorgar &&
               window.BrutechPartners.brands.lorgar.models) || {};
    }
    var t = name.toLowerCase(), bestLen = 0, best = null;
    for (var k in TIERS) {
      if (!TIERS.hasOwnProperty(k)) continue;
      if (t.indexOf(k) !== -1 && k.length > bestLen) {
        bestLen = k.length;
        best = TIERS[k];
      }
    }
    return best;
  }

  function tagCard(card) {
    if (card.dataset.lorgarChecked) return;
    card.dataset.lorgarChecked = '1';

    var nameEl = card.querySelector('.pcb__card-name');
    var name = (nameEl ? nameEl.textContent : '') + ' ' + (card.dataset.name || '');
    if (name.toLowerCase().indexOf('lorgar') === -1) return;

    card.classList.add('is-lorgar');

    var info = card.querySelector('.pcb__card-info');
    if (!info || info.querySelector('.pcb__card-lorgar')) return;

    var tier = tierFor(name);
    var badge = document.createElement('span');
    badge.className = 'pcb__card-lorgar';
    if (tier) badge.setAttribute('data-tier', tier);
    badge.textContent = tier ? 'LORGAR · ' + tier.toUpperCase() : 'LORGAR';

    info.insertBefore(badge, info.firstChild);
  }

  function scanBuilder() {
    document.querySelectorAll('.pcb__card:not([data-lorgar-checked])').forEach(tagCard);
  }

  function initBuilder() {
    var host = document.querySelector('.pcb, [class*="pcb__"]');
    if (!host) return;

    scanBuilder();

    /* Cards are re-rendered on every step change */
    new MutationObserver(function () { scanBuilder(); })
      .observe(document.body, { childList: true, subtree: true });
  }

  /* ── 7. RUN ── */
  function scan() {
    document.querySelectorAll('.product-card:not([data-brutech-partner])').forEach(brandCard);
  }

  function init() {
    try {
      scan();
      initTakeover();
      initProductPage();
      initBuilder();
      var grid = document.querySelector('#main-collection-product-grid, .collection__products, main');
      if (grid) {
        new MutationObserver(function () { scan(); })
          .observe(grid, { childList: true, subtree: true });
      }
    } catch (e) { console.warn('[Brutech] Partner system:', e); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  /* Expose for the bundle module */
  window.BrutechPartners = {
    brands: PARTNER_BRANDS,
    detectBrand: detectBrand,
    detectCategory: detectCategory
  };
})();
